import * as React from 'react';

function SvgDownload(props) {
  return (
    <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M10.061 4v9.122M6.829 9.89l3.232 3.232 3.233-3.233M3.5 16.5h13"
        stroke={props.color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SvgDownload;
